export default {
  FAST: 'fast',
  REGULAR: 'regular',
};
